import { render, staticRenderFns } from "./bell-hill-vineyards.vue?vue&type=template&id=18b229a3&scoped=true"
import script from "./bell-hill-vineyards.vue?vue&type=script&lang=js"
export * from "./bell-hill-vineyards.vue?vue&type=script&lang=js"
import style0 from "./bell-hill-vineyards.vue?vue&type=style&index=0&id=18b229a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b229a3",
  null
  
)

export default component.exports